// MainPage.js
import React from 'react';
import { FaCheckCircle, FaMobile, FaWhatsapp, FaMailBulk, FaArrowAltCircleRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom'; // Import icons
import broImage from '../images/bro.png'

export const MainPage = () => {
    const navigate = useNavigate();
    const handlelogin = () => {
        navigate('/login');
    }

    const handlesignup = () => {
        navigate('/signup');
    }
    return (
        <div className="bg-gray-100 min-h-screen font-sans">
            {/* Header Section */}
            <header className="bg-blue-600 text-white py-12 relative flex items-center flex-col md:flex-row">
                <img
                    src={broImage}
                    alt="Bro"
                    className="w-48 h-48 md:w-52 md:h-52 mx-4 md:mx-8 mb-4 md:mb-0"
                />
                <div className="container mx-auto text-center md:text-left">
                    <h1 className="text-4xl font-bold mb-2">PGDOST - Find Your Perfect Bro 🤜🤛</h1>
                    <p className="text-lg">Connecting people with shared living spaces</p>
                    <button
                        className="flex items-center bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mt-4 ml-4 md:ml-0"
                        onClick={handlelogin}
                    >
                        Get Started <FaArrowAltCircleRight className="ml-2" />
                    </button>
                </div>
            </header>

            {/* Features Section */}
            <section className="py-16 bg-gray-100">
                <div className="container mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-8">Why PGDOST?</h2>
                    <div className="flex flex-wrap justify-center">
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <div className="flex items-center justify-center mb-4">
                                <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                                    <FaCheckCircle size={30} />
                                </div>
                                <h3 className="text-xl font-bold">Easy Room Posting</h3>
                            </div>
                            <p>Post your room details effortlessly and attract potential roommates.</p>
                        </div>
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <div className="flex items-center justify-center mb-4">
                                <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                                    <FaCheckCircle size={30} />
                                </div>
                                <h3 className="text-xl font-bold">Browse Available Rooms</h3>
                            </div>
                            <p>Explore a variety of rooms and find the one that suits your preferences.</p>
                        </div>
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <div className="flex items-center justify-center mb-4">
                                <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                                    <FaCheckCircle size={30} />
                                </div>
                                <h3 className="text-xl font-bold">Instant Communication</h3>
                            </div>
                            <p>Contact potential roommates via call or WhatsApp directly from the platform.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonial Section */}
            <section className="py-16 bg-gray-200">
                <div className="container mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-8">What Our Users Say</h2>
                    <div className="flex flex-wrap justify-center">
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <blockquote className="border-l-4 border-green-500 pl-4">
                                <p className="text-lg">
                                    "PGDOST made finding a roommate incredibly easy. The platform is user-friendly, and I found
                                    the perfect living situation in no time!"
                                </p>
                                <cite className="mt-4 block text-gray-600">- Sarah, PGDOST User</cite>
                            </blockquote>
                        </div>
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <blockquote className="border-l-4 border-green-500 pl-4">
                                <p className="text-lg">
                                    "I was skeptical at first, but PGDOST exceeded my expectations. The communication features
                                    are convenient, and I now share an amazing apartment with a fantastic roommate."
                                </p>
                                <cite className="mt-4 block text-gray-600">- John, PGDOST User</cite>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </section>

            {/* Call to Action Section */}
            <section className="py-16 bg-gray-300">
                <div className="container mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-4">Ready to Find Your Perfect Roommate?</h2>
                    <p className="text-lg mb-8">
                        Get started now by posting your room or searching for available rooms.
                    </p>
                    <div className="flex justify-center items-center">
                        <button className="bg-green-500 hover:bg-green-700 text-white font-bold py-3 px-6 rounded" onClick={handlelogin}>
                            Get Started
                        </button>
                    </div>
                </div>
            </section>

            {/* Registration Section */}
            <section className="py-16 bg-blue-600 text-white">
                <div className="container mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-4">Join PGDOST Today</h2>
                    <p className="text-lg mb-8">Sign up now to start your roommate search journey!</p>
                    <div className="flex justify-center items-center">
                        <button className="bg-white text-blue-600 hover:bg-blue-700 hover:text-white font-bold py-3 px-6 rounded" onClick={handlesignup}>
                            Sign Up
                        </button>
                    </div>
                </div>
            </section>

            {/* Contact Section */}
            <section className="py-16 bg-gray-100">
                <div className="container mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
                    <div className="flex flex-wrap justify-center">
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <div className="flex items-center justify-center mb-4">
                                <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                                    <FaMailBulk size={30} />
                                </div>
                                <p className="text-xl font-bold">Mail Us</p>
                            </div>
                            <p>Have questions? Mail us at noreply.pgdost@gmail.com</p>
                        </div>
                        <div className="w-full md:w-1/2 lg:w-1/3 p-4">
                            <div className="flex items-center justify-center mb-4">
                                <div className="bg-green-500 text-white rounded-full p-3 mr-4">
                                    <FaWhatsapp size={30} />
                                </div>
                                <p className="text-xl font-bold">WhatsApp</p>
                            </div>
                            <p>Reach out to us on WhatsApp at +91-9675635863</p>
                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
};
